/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://txyrk3ik3fbadhdjaqpard7die.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "learnserbianappRESTapi",
            "endpoint": "https://h6nrzhl63i.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:29a8b5bb-05fa-4fb2-b9ce-1ae183a2d55f",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_x0SK7PJdT",
    "aws_user_pools_web_client_id": "3gd5sqmhbvvjvl1nv72fa1oq5i",
    "oauth": {
        "domain": "learnserbianapp-dev.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://learnserbianapp-dev.auth.eu-central-1.amazoncognito.com/oauth2/idpresponse/,https://www.fluentserbian.com/oauth2/idresponse/,https://fluentserbian.com/oauth2/idresponse/",
        "redirectSignOut": "http://localhost:3000/,https://fluentserbian.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "learnserbianappa7c790378ace4c7d8388048c388dfa29a18b1-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
